<template>
    <div class="main">
        <admin-navigation></admin-navigation>
        <div class="content-area">
            <div class="page-header">
                <div class="page-details">
                    <h2>Dashboard</h2>
                    <ul class="breadcrumbs">
                         <li>
                            <router-link :to="'/dashboard'" class="current">Dashboard</router-link>
                        </li>
                    </ul>
                </div>
                <div class="actions multiple">
                    <div class="filter">
                        <div class="filter__header">
                            <span class="filter__label">
                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.83317 5.83332H5.8415M17.1582 11.175L11.1832 17.15C11.0284 17.305 10.8446 17.4279 10.6422 17.5118C10.4399 17.5956 10.223 17.6388 10.004 17.6388C9.78498 17.6388 9.5681 17.5956 9.36577 17.5118C9.16344 17.4279 8.97963 17.305 8.82484 17.15L1.6665 9.99999L1.6665 1.66666L9.99984 1.66666L17.1582 8.82499C17.4686 9.13726 17.6428 9.55968 17.6428 9.99999C17.6428 10.4403 17.4686 10.8627 17.1582 11.175Z" stroke="#F32752" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <span class="filter__value"></span>
                            <span class="filter__icon">
                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </span>
                        </div>
                        <div class="filter__dropdown right shadow" style="display: none;">
                            <div class="input-radio" data-active="false" group="sample1" v-for="tag in tags" @click="getFilterData('tag',tag.id)">
                                <input type="radio" name="active" id="" />
                                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect class="border" x="0.75" y="0.75" width="17.0735" height="16.4093" rx="8.20464" stroke="#F32752" stroke-width="1.5" />
                                    <circle class="checkmark" cx="9.35472" cy="8.95463" r="5.53086" fill="#F32752" />
                                </svg>
                                <label for="DS1">{{tag.name}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="filter">
                        <div class="filter__header">
                            <span class="filter__label">
                                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.1113 8.33334C18.1113 14.1667 10.6113 19.1667 10.6113 19.1667C10.6113 19.1667 3.11133 14.1667 3.11133 8.33334C3.11133 6.34422 3.9015 4.43656 5.30803 3.03004C6.71455 1.62352 8.6222 0.833344 10.6113 0.833344C12.6005 0.833344 14.5081 1.62352 15.9146 3.03004C17.3212 4.43656 18.1113 6.34422 18.1113 8.33334Z" stroke="#F32752" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.6113 10.8333C11.992 10.8333 13.1113 9.71405 13.1113 8.33334C13.1113 6.95263 11.992 5.83334 10.6113 5.83334C9.23062 5.83334 8.11133 6.95263 8.11133 8.33334C8.11133 9.71405 9.23062 10.8333 10.6113 10.8333Z" stroke="#F32752" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <span class="filter__value"></span>
                            <span class="filter__icon">
                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </span>
                        </div>
                        <div class="filter__dropdown right shadow" style="display: none;">
                            <div class="input-radio" data-active="false" group="sample1" v-for="location in locations" @click="getFilterData('location',location.id)">
                                <input type="radio" name="active" id="" />
                                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect class="border" x="0.75" y="0.75" width="17.0735" height="16.4093" rx="8.20464" stroke="#F32752" stroke-width="1.5" />
                                    <circle class="checkmark" cx="9.35472" cy="8.95463" r="5.53086" fill="#F32752" />
                                </svg>
                                <label for="DS1">{{location.name}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="filter">
                        <div class="filter__header">
                            <VueDatePicker v-model="select_date" :color="admin_color" />
                        </div>
                    </div>
                    <button type="button" class="btn filter-button" @click="getData">Filter</button>
                </div>
            </div>
            <div class="section">
                <div class="section__header">
                    <div class="section__title">
                        <h5>Overview</h5>
                        <p>Live status of total users in this location</p>
                    </div>
                    <div class="section__actions"></div>
                </div>
                <div class="section__body">
                    <div class="viewgraph">
                        <div class="viewgraph__card">
                            <div class="viewgraph__details">
                                <h3>{{totalUsers}}</h3>
                                <p>Total Users</p>
                            </div>
                            <div class="viewgraph__icon">
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M25.5 31.3279V28.3279C25.5 26.7366 24.8679 25.2105 23.7426 24.0852C22.6174 22.96 21.0913 22.3279 19.5 22.3279H7.5C5.9087 22.3279 4.38258 22.96 3.25736 24.0852C2.13214 25.2105 1.5 26.7366 1.5 28.3279V31.3279M34.5 31.3279V28.3279C34.499 26.9985 34.0565 25.707 33.242 24.6564C32.4276 23.6057 31.2872 22.8552 30 22.5229M24 4.52288C25.2906 4.85333 26.4346 5.60393 27.2515 6.65635C28.0684 7.70876 28.5118 9.00313 28.5118 10.3354C28.5118 11.6676 28.0684 12.962 27.2515 14.0144C26.4346 15.0668 25.2906 15.8174 24 16.1479M19.5 10.3279C19.5 13.6416 16.8137 16.3279 13.5 16.3279C10.1863 16.3279 7.5 13.6416 7.5 10.3279C7.5 7.01417 10.1863 4.32788 13.5 4.32788C16.8137 4.32788 19.5 7.01417 19.5 10.3279Z" stroke="#848484" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <div class="viewgraph__card viewgraph--outlined-secondary">
                            <div class="viewgraph__details">
                                <h3>{{totalUsersNotStarted}}</h3>
                                <p>Not Started</p>
                            </div>
                            <div class="viewgraph__icon">
                                <img :src="base_url + '/admin/img/notstarted-icon.png'" />
                            </div>
                        </div>
                        <div class="viewgraph__card viewgraph--outlined-primary">
                            <div class="viewgraph__details">
                                <h3>{{totalUsersCheckIn}}</h3>
                                <p>Checked In</p>
                            </div>
                            <div class="viewgraph__icon">
                                <img :src="base_url + '/admin/img/checkin-icon.png'" />
                            </div>
                        </div>
                        <div class="viewgraph__card viewgraph--primary">
                            <div class="viewgraph__details">
                                <h3>{{totalUsersCheckOut}}</h3>
                                <p>Checked Out</p>
                            </div>
                            <div class="viewgraph__icon">
                                <img :src="base_url + '/admin/img/checkedout-icon.png'" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrapper-row">
                <div class="section">
                    <div class="section__header">
                        <div class="section__title">
                            <h5>Absent</h5>
                        </div>
                        <div class="section__actions">
                            <router-link :to="{ name: 'detailed-report' }">View All</router-link>
                        </div>
                    </div>
                    <div class="section__body">
                        <div class="user__list" v-if="users_absent.length">
                            <div class="user__entry" v-for="user in users_absent">
                                <div class="user__detail">
                                    <div class="user__img">
                                        <img v-if="user.image != ''" :src="user.image" />
                                        <img v-if="user.image == ''" :src="base_url + 'admin/img/user-avatar.jpeg'" />
                                    </div>
                                    <div class="user__title">
                                        <router-link :to="{ name: 'employees-detail', params: {slug: user.id } }">{{user.name}}</router-link>
                                        <p>{{user.designation}} | {{user.phone}}</p>
                                    </div>
                                </div>
                                <div class="user__time"></div>
                            </div>
                        </div>
                        <div class="empty-state" v-else>
                            <img :src="base_url + '/admin/img/empty-absent.svg'" alt="" />
                            <h5>No Absentees Yet</h5>
                            <p>Looks like there are no users records for this date. <br />Kindly select another date for data</p>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="section__header">
                        <div class="section__title">
                            <h5 class="text-primary">Present <small>(CheckIn - CheckOut)</small></h5>
                        </div>
                        <div class="section__actions" v-if="users_checkin.length">
                            <router-link :to="{ name: 'detailed-report' }">View All</router-link>
                        </div>
                    </div>
                    <div class="section__body">
                        <div class="user__list" v-if="users_checkin.length">
                            <div class="user__entry" v-for="user in users_checkin">
                                <div class="user__detail">
                                    <div class="user__img">
                                        <img v-if="user.image != ''" :src="user.image" />
                                        <img v-if="user.image == ''" :src="base_url + 'admin/img/user-avatar.jpeg'" />
                                    </div>
                                    <div class="user__title">
                                        <router-link :to="{ name: 'employees-detail', params: {slug: user.id } }">{{user.name}}</router-link>
                                        <p>{{user.designation}} | {{user.phone}}</p>
                                    </div>
                                </div>
                                <div class="user__time">{{user.check_in}} - {{user.check_out}}</div>
                            </div>
                        </div>
                        <div class="empty-state" v-else>
                            <img :src="base_url + '/admin/img/empty-absent.svg'" alt="" />
                            <h5>No Attendees Yet</h5>
                            <p>Looks like there are no users records for this date. <br />Kindly select another date for data</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            totalUsers: 0,
            totalUsersNotStarted: 0,
            totalUsersCheckIn: 0,
            totalUsersCheckOut: 0,
            users_absent: [],
            users_checkin: [],
            tags: [],
            locations: [],
            select_tag: null,
            select_location: null,
            select_date:null,
        }
    },
    created() {

        this.getData();
        this.getTags();
        this.getLocations();

    },
    methods: {
        getData() {
            
            axios.get('/api/admin/dashboard-view?tag_id=' + this.select_tag + '&location_id=' + this.select_location + '&date=' + this.select_date, {}).then(response => {
                this.totalUsers = response.data.data.total_users;
                this.totalUsersNotStarted = response.data.data.total_users_not_started;
                this.totalUsersCheckIn = response.data.data.total_users_check_in;
                this.totalUsersCheckOut = response.data.data.total_users_check_out;
                this.users_absent = response.data.data.users_absent;
                this.users_checkin = response.data.data.users_checkin;
            }).catch(error => {
                this.$root.erroHandler(error);
            });
        },
        getTags() {
            axios.get("/api/admin/tags", {}).then(response => {
                this.tags = response.data.data;
            }).catch(error => {

                this.$root.erroHandler(error);
            });
        },
        getLocations() {
            axios.get("/api/admin/locations", {}).then(response => {
                this.locations = response.data.data.records;
            });
        },
        getFilterData(type, id) {
            if (type == 'tag') {
                this.select_tag = id;
            } else {
                this.select_location = id;
            }
        },

    }
}

</script>
